/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Add_ResourceInputs */

const en_admin_resource_form_add_resource = /** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Resource`)
};

const de_admin_resource_form_add_resource = /** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource hinzufügen`)
};

const es_admin_resource_form_add_resource = /** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir recurso`)
};

const fr_admin_resource_form_add_resource = /** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une ressource`)
};

/** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */
const it_admin_resource_form_add_resource = en_admin_resource_form_add_resource;

/** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */
const pt_br2_admin_resource_form_add_resource = en_admin_resource_form_add_resource;

/** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */
const pl_admin_resource_form_add_resource = en_admin_resource_form_add_resource;

/** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */
const hu_admin_resource_form_add_resource = en_admin_resource_form_add_resource;

/** @type {(inputs: Admin_Resource_Form_Add_ResourceInputs) => LocalizedString} */
const ro_admin_resource_form_add_resource = en_admin_resource_form_add_resource;

/**
* | output |
* | --- |
* | "Add Resource" |
*
* @param {Admin_Resource_Form_Add_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_add_resource = /** @type {((inputs?: Admin_Resource_Form_Add_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Add_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_add_resource(inputs)
	if (locale === "de") return de_admin_resource_form_add_resource(inputs)
	if (locale === "es") return es_admin_resource_form_add_resource(inputs)
	if (locale === "fr") return fr_admin_resource_form_add_resource(inputs)
	if (locale === "it") return it_admin_resource_form_add_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_add_resource(inputs)
	if (locale === "pl") return pl_admin_resource_form_add_resource(inputs)
	if (locale === "hu") return hu_admin_resource_form_add_resource(inputs)
	return ro_admin_resource_form_add_resource(inputs)
});
export { admin_resource_form_add_resource as "admin.resource_form.add_resource" }